<template>
<div class="column is-one-third-desktop is-half-tablet is-full-mobile">
    <div class="card">
        <!-- <div class="card-image">
            <figure class="image is-4by3">
            <img src="https://bulma.io/images/placeholders/1280x960.png" alt="Placeholder image">
            </figure>
        </div> -->
        <div class="card-content">
            <div class="media">
            <div class="media-left">
                <figure class="image is-48x48">
                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                </figure>
            </div>
            <div class="media-content">
                <p class="title is-4">{{unit.name}}</p>
                <p class="subtitle is-7">{{ unit.type }}</p>
            </div>
            </div>

            <h2 class="is-size-6 mb-2 pb-1 has-text-centered" style="font-weight:bold; text-transform:uppercase; border-bottom:1px solid #ddd;">This Battle</h2>
            <nav class="level is-mobile mb-2">
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">KILLS</p>
                    <p class="title is-size-4">{{ total_kills }}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">MELEE</p>
                    <p class="title is-size-4">{{this.unit.draft_info.combat.melee}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">RANGED</p>
                    <p class="title is-size-4">{{this.unit.draft_info.combat.ranged}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">PSYCHIC</p>
                    <p class="title is-size-4">{{this.unit.draft_info.combat.psychic}}</p>
                    </div>
                </div>
            </nav>

            <h2 class="is-size-6 mb-2 pb-1 has-text-centered" style="font-weight:bold; text-transform:uppercase; border-bottom:1px solid #ddd;">New Total</h2>
            <nav class="level is-mobile mb-0">
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">KILLS</p>
                    <p class="title is-size-4">{{ total_kills + combat_totals.any || 0 }}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">MELEE</p>
                    <p class="title is-size-4">{{this.unit.draft_info.combat.melee + combat_totals.melee || 0}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">RANGED</p>
                    <p class="title is-size-4">{{this.unit.draft_info.combat.ranged + combat_totals.ranged || 0}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                    <p class="heading">PSYCHIC</p>
                    <p class="title is-size-4">{{this.unit.draft_info.combat.psychic + combat_totals.psychic || 0}}</p>
                    </div>
                </div>
            </nav>
            
            <h2 class="is-size-6 mb-2 mt-3 pb-1 has-text-centered" style="font-weight:bold; text-transform:uppercase; border-bottom:1px solid #ddd;">Experience</h2>

            <div class="">
                <change-flow field="experience" :current_value="unit.experience_pts" :new_value="unit.draft_info.new_experience_pts"></change-flow>
                <change-flow field="rank" :current_value="unit.rank" :new_value="unit.draft_info.new_rank"></change-flow>
                <change-flow field="crusade pts" :current_value="unit.crusade_pts" :new_value="unit.draft_info.new_crusade_pts"></change-flow>
            </div>

            <h2 v-if="unit.draft_info.battle_scars || unit.draft_info.new_honours"
                class="is-size-6 mb-2 mt-3 pb-1 has-text-centered" style="font-weight:bold; text-transform:uppercase; border-bottom:1px solid #ddd;">
                Honour &amp; Scars</h2>

            <div v-if="unit.draft_info.battle_scars" class="mt-3">
                <div  v-for="(scar,index) in unit.draft_info.battle_scars" :key="`scar${index}`" style="align-items:center;display:flex;"> 
                    <b-icon icon="heart-broken" class="is-size-7 mr-2"></b-icon> {{scar.title}}
                </div>
                
            </div>
            
            <div v-if="unit.draft_info.new_honours" class="mt-3">
                <div class="columns is-vcentered" v-for="(honour,index) in unit.draft_info.new_honours" :key="`honor${index}`" > 
                    <div class="column is-narrow pr-0 pt-5" style=""><b-icon icon="trophy" class="is-size-7 mr-1 mb-0"></b-icon> </div>
                    <div class="column is-narrow pl-1">
                        <div class="is-size-7">{{honour.type}}</div>
                        <div class="is-size-6">{{honour.details}}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="content">
                {{ unit.draft_info }}
            <a href="#">#css</a> <a href="#">#responsive</a>
            <br>
            <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
import ChangeFlow from './ChangeFlow.vue'
export default {
    props: ['unit'],
    components: { ChangeFlow },
    computed: {
        total_kills() { 
            let combat = this.unit.draft_info.combat
            return combat.melee + combat.ranged + combat.psychic
        },
        combat_totals() {
            let blank_totals = { "psychic": 0, "ranged": 0, "melee": 0, "any": 0 } 
            return this.unit.combat_totals || blank_totals
        },
    },
}
</script>

